var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      attrs: {
        visible: _vm.isVisible,
        title: _vm.dialogTitle,
        size: "small",
        closeOnClickOverlay: false
      },
      on: {
        "update:visible": function($event) {
          _vm.isVisible = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function() {
            return [
              _c(
                "section",
                { staticClass: "activity-delete-dialog-footer__container" },
                [
                  _c("CompassButton", {
                    attrs: {
                      type: "secondary",
                      label: _vm.cancelButtonLabel,
                      disabled: _vm.pending
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassButton", {
                    attrs: {
                      loading: _vm.pending,
                      type: "primary-destructive",
                      label: _vm.confirmButtonLabel
                    },
                    on: { click: _vm.onDelete }
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("p", {
        staticClass:
          "typographies-paragraph-medium-regular activities-dialog__content",
        domProps: { innerHTML: _vm._s(_vm.dialogContent) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }